import { render, staticRenderFns } from "./FileUploadWithPreview.vue?vue&type=template&id=2af067bf"
import script from "./FileUploadWithPreview.vue?vue&type=script&lang=js"
export * from "./FileUploadWithPreview.vue?vue&type=script&lang=js"
import style0 from "./FileUploadWithPreview.vue?vue&type=style&index=0&id=2af067bf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports